import { selectSearchState } from "../../selectors/shared";

const emptyObject = {};
const firstDefined = (...values) => {
  const value = values.find((item) => item !== undefined && item !== null);

  return value !== undefined ? value : values[values.length - 1];
};

export const selectSearchUiDomain = (state) => {
  const search = selectSearchState(state);
  const ui = search.ui ?? emptyObject;

  return {
    isNewSearch: firstDefined(search.isNewSearch, true),
    isNewPage: firstDefined(search.isNewPage, false),
    imageGalleryOnboardDismissed: search.imageGalleryOnboardDismissed,
    redirectUrl: firstDefined(search.redirectUrl, ""),
    error: search.error,
    isInitialLoading: firstDefined(
      ui.isInitialLoading,
      search.isLoading,
      false,
    ),
    isPagingForward: firstDefined(
      ui.isPagingForward,
      search.isLoadingMore,
      false,
    ),
    isPagingBackward: firstDefined(
      ui.isPagingBackward,
      search.isLoadingPrevious,
      false,
    ),
    lastError: firstDefined(ui.lastError, search.error, null),
  };
};

export const selectSearchIsInitialLoading = (state) =>
  selectSearchUiDomain(state).isInitialLoading;

export const selectSearchIsPagingForward = (state) =>
  selectSearchUiDomain(state).isPagingForward;

export const selectSearchIsPagingBackward = (state) =>
  selectSearchUiDomain(state).isPagingBackward;

export const selectSearchIsNewSearch = (state) =>
  selectSearchUiDomain(state).isNewSearch;

export const selectSearchIsNewPage = (state) =>
  selectSearchUiDomain(state).isNewPage;

export const getIsLoading = ({ search: { isLoading } }) => isLoading;

export const getIsLoadingPrevious = ({ search: { isLoadingPrevious } }) =>
  isLoadingPrevious;

export const getImageGalleryOnboardDismissed = ({
  search: { imageGalleryOnboardDismissed },
}) => imageGalleryOnboardDismissed;

export const getIsNewSearch = ({ search: { isNewSearch } }) => isNewSearch;

export const getIsNewPage = ({ search: { isNewPage } }) => isNewPage;
